import Swiper from './components/Swiper'
import Slide from './components/Slide'
import LSlide from './components/LSlide'
import HeaderNav from './components/HeaderNav'
import BigImg from "./components/BigImg/BigImg";
import SuccessBeforeItem from './components/SuccessBeforeItem'
import WordsBeforeItem from './components/240WordsBeforeItem'
import BigCatBeforeItem from './components/BigCatBefore'
import BigCat5Item from './components/BigCat5Item'
import WorksheetItem from './components/WorksheetItem'

const install = Vue => {
    Vue.component('HeaderNav', HeaderNav);
    Vue.component('big-img', BigImg);
    Vue.component('SuccessBeforeItem', SuccessBeforeItem);
    Vue.component('WordsBeforeItem', WordsBeforeItem);
    Vue.component('BigCatBeforeItem', BigCatBeforeItem);
    Vue.component('Swiper', Swiper);
    Vue.component('Slide', Slide);
    Vue.component('LSlide', LSlide);
    Vue.component('BigCat5Item', BigCat5Item);
    Vue.component('WorksheetItem', WorksheetItem);
};

export default install
